<template>
  <v-list v-if="mode === 'list'" two-line>
    <v-list-item-group active-class="blue-grey--text">
      <template v-for="(item, index) in items">
        <v-list-item :key="item.data.slug">
          <v-list-item-icon>
            <lean-list-item-checkbox :record="item" />
          </v-list-item-icon>
          <lean-list-item-content :record="item.resolved_data" :listConfig="listConfig" @click="editItem(item)">
            <template v-slot:actions>
              <v-list-item-action-text v-text="item.data.status"></v-list-item-action-text>
              <div class="d-flex">
                <lean-is-published :record="item" />
              </div>
            </template>
          </lean-list-item-content>
        </v-list-item>
        <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
      </template>
    </v-list-item-group>
  </v-list>
  <v-container fluid v-else-if="mode === 'cards'">
    <v-row dense>
      <v-col v-for="item in items" :key="item.data.slug" :cols="3">
        <lean-list-item-card :record="item.resolved_data" :listConfig="listConfig" @click="editItem(item)">
          <template v-slot:actions>
            <v-list-item-action-text v-text="item.data.status"></v-list-item-action-text>
            <div class="d-flex">
              <lean-is-published :path="item.filename" />
            </div>
          </template>
        </lean-list-item-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LeanListItemContent from '@/components/LeanListItemContent.vue';
import LeanListItemCard from '@/components/LeanListItemCard.vue';
import LeanIsPublished from '@/components/LeanIsPublished';
import { mapState } from 'vuex';
import LeanListItemCheckbox from '@/components/LeanListItemCheckbox';

export default {
  name: 'LeanListItems',
  components: {
    LeanListItemCheckbox,
    LeanIsPublished,
    LeanListItemContent,
    LeanListItemCard
  },
  props: {
    records: {
      type: Array,
      default: () => []
    },
    listConfig: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    datatype: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      datatypes: 'models',
      language: 'selectedLanguage'
    }),
    localizedDatatype() {
      if (this.datatypes[this.datatype].title && this.datatypes[this.datatype].title[this.language]) {
        return this.datatypes[this.datatype].title[this.language];
      } else {
        return this.datatype;
      }
    },
    items() {
      return this.records
        .filter((record) => record.filename.indexOf(this.$store.state.search.toLowerCase()) > -1)
        .map((record) => {
          record.data.slug = record.slug;
          return record;
        });
    }
  },
  methods: {
    toggleMode() {
      if (this.mode === 'list') {
        this.mode = 'cards';
      } else {
        this.mode = 'list';
      }
    },
    editItem(record) {
      const chunks = record.filename.split('/');
      this.$router.push({ path: `/data/${this.datatype}/${chunks[2]}` });
    }
  }
};
</script>
